export enum UserNumberOfInjectionsEnum {
    NONE = 'NONE',
    INJECTIONS_1_TO_5 = 'INJECTIONS_1_TO_5',
    INJECTIONS_6_TO_10 = 'INJECTIONS_6_TO_10',
    INJECTIONS_11_TO_20 = 'INJECTIONS_11_TO_20',
    INJECTIONS_MORE_THAN_20 = 'INJECTIONS_MORE_THAN_20'
}

